import { Button, Tag } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/auth.slice";
import CreateGroupWakeupAlarmModal from "../CreateGroupWakeupAlarmModal";
import GroupListScreen from "../GroupListScreen";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupWakeupAlarms } from "../../../services/groupConsole.service";

const GroupWakeupAlarms = () => {
  const user = useSelector(selectUser);
  const branches = useGroupBranchOptions();
  const [showCreate, setShowCreate] = useState(false);

  return (
    <>
      <GroupListScreen
        title="Wake-up Alarms"
        queryKey="group-console-wakeup-alarms"
        fetchFn={fetchGroupWakeupAlarms}
        searchPlaceholder="Search"
        branchOptions={branches.options}
        branchOptionsLoading={branches.isLoading}
        extraHeader={
          <Button type="primary" onClick={() => setShowCreate(true)}>
            Create Alarm
          </Button>
        }
        columns={[
          { title: "Scope", dataIndex: "scope", align: "center" },
          {
            title: "Time",
            key: "time",
            align: "center",
            render: (r) => r.recurrence?.at_time || "—",
          },
          {
            title: "Active",
            dataIndex: "is_active",
            align: "center",
            render: (active) =>
              active ? <Tag color="green">Active</Tag> : <Tag>Inactive</Tag>,
          },
        ]}
      />
      <CreateGroupWakeupAlarmModal
        groupId={user?.group}
        open={showCreate}
        onClose={() => setShowCreate(false)}
      />
    </>
  );
};

export default GroupWakeupAlarms;
